import { useEffect, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
import { getPage, useSearchContent } from '@juno/client-api';
import { Page } from '@juno/client-api/model';
import { useSettings } from '../routing/RoutingMediator';

export function usePageSearch(pageId?: string) {
  const { site } = useSettings();
  const [page, setPage] = useState<Page | undefined>(undefined);
  const [search, setSearch] = useState<string | null>(null);

  const [debouncedSearch] = useDebounceValue(search, 300);
  const { data: searchData, isFetching } = useSearchContent(
    site?.id || '',
    { search_term: debouncedSearch || '', content_types: 'page' },
    { query: { enabled: !!debouncedSearch } },
  );

  useEffect(() => {
    const fetchAndSetPage = async (pageId: string | undefined) => {
      if (!pageId?.trim()) return setPage(undefined);
      try {
        const page = await getPage(site?.id || '', pageId);
        setPage(page);
      } catch {
        setPage(undefined);
      }
    };
    fetchAndSetPage(pageId);
  }, [pageId, site?.id]);

  return {
    page,
    setPage,
    search,
    setSearch,
    searchData,
    isFetching,
  };
}
